import { useState } from "react";
import {
  LuDownload as FiDownload,
  LuFilter as FiFilter,
  LuX as FiX,
} from "react-icons/lu";
import "./style.css";

export const normalizeSearch = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase();
export const filterCollection = (rows, filters, values, tab) =>
  rows.filter(
    (row) =>
      (!tab?.matches || tab.matches(row)) &&
      filters.every(
        (filter) =>
          !values[filter.key] || filter.matches(row, values[filter.key]),
      ),
  );
const csvCell = (value) =>
  '"' +
  String(value ?? "")
    .replace(/^[=+@-]/, "'$&")
    .replace(/"/g, '""') +
  '"';
export const exportCollection = (rows, columns, name) => {
  const csv = [
    columns.map((column) => csvCell(column.label)).join(";"),
    ...rows.map((row) =>
      columns.map((column) => csvCell(column.value(row))).join(";"),
    ),
  ].join("\r\n");
  const url = URL.createObjectURL(
    new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = `${name}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
export const CollectionTools = ({ rows, config, children }) => {
  const [values, setValues] = useState({});
  const [showColumns, setShowColumns] = useState(false);
  const [tabId, setTabId] = useState(config.tabs?.[0]?.id);
  const filters = config.filters || [];
  const tab = config.tabs?.find((item) => item.id === tabId);
  const visible = filterCollection(rows, filters, values, tab);
  const hasFilters = Object.values(values).some(Boolean);
  return (
    <div
      className={`collectionWorkbench ${showColumns ? "collectionShowColumns" : ""}`}
    >
      {config.tabs?.length > 0 && (
        <div className="collectionTabs" aria-label="Vistas del listado">
          {config.tabs.map((item) => (
            <button
              key={item.id}
              type="button"
              aria-pressed={item.id === tabId}
              onClick={() => setTabId(item.id)}
            >
              {item.label}
              <span>
                {
                  rows.filter((row) => !item.matches || item.matches(row))
                    .length
                }
              </span>
            </button>
          ))}
        </div>
      )}
      <div className="collectionToolbar">
        <div className="collectionFilters">
          <FiFilter aria-hidden="true" />
          {filters.map((filter) => (
            <label key={filter.key}>
              {filter.label}
              <select
                value={values[filter.key] || ""}
                onChange={(event) =>
                  setValues((previous) => ({
                    ...previous,
                    [filter.key]: event.target.value,
                  }))
                }
              >
                <option value="">{filter.allLabel || "Todos"}</option>
                {filter.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </label>
          ))}
          {hasFilters && (
            <button type="button" onClick={() => setValues({})}>
              <FiX aria-hidden="true" /> Limpiar filtros
            </button>
          )}
        </div>
        {config.exportColumns && (
          <button
            type="button"
            onClick={() =>
              exportCollection(
                visible,
                config.exportColumns,
                config.exportName || "listado",
              )
            }
          >
            <FiDownload aria-hidden="true" /> Exportar CSV
          </button>
        )}
      </div>
      <button
        type="button"
        className="collectionMobileTools"
        aria-expanded={showColumns}
        onClick={() => setShowColumns((previous) => !previous)}
      >
        {showColumns
          ? "Ocultar ordenación y columnas"
          : "Ordenación y columnas"}
      </button>
      <p className="collectionResult" role="status">
        {visible.length} de {rows.length} registros
        {tab?.label ? ` · ${tab.label}` : ""}
      </p>
      {visible.length ? (
        children(visible)
      ) : (
        <div className="collectionNoMatch">
          <h3>No hay resultados para estos filtros</h3>
          <p>
            Cambia los filtros o vuelve a Todos para ver el listado completo.
          </p>
          <button
            type="button"
            onClick={() => {
              setValues({});
              setTabId(config.tabs?.[0]?.id);
            }}
          >
            Restablecer vista
          </button>
        </div>
      )}
    </div>
  );
};
export const CollectionSummary = ({ items }) => (
  <div className="adminListSummary">
    {items.map((item) => (
      <div key={item.label}>
        {item.icon && (
          <div className="adminSummaryIcon" aria-hidden="true">
            {item.icon}
          </div>
        )}
        <div className="adminSummaryContent">
          <span>{item.label}</span>
          <strong>{item.value}</strong>
          {item.detail && <small>{item.detail}</small>}
        </div>
      </div>
    ))}
  </div>
);
export const activeValue = (value) => value === true || value === 1;
export const activeFilter = {
  key: "active",
  label: "Estado",
  allLabel: "Todos los estados",
  options: [
    { value: "active", label: "Activos" },
    { value: "inactive", label: "Inactivos" },
  ],
  matches: (row, value) => activeValue(row.isActive) === (value === "active"),
};
